import { render, staticRenderFns } from "./DynamicAttributeConfigurationSluggableSource.vue?vue&type=template&id=4253e9c3&"
import script from "./DynamicAttributeConfigurationSluggableSource.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeConfigurationSluggableSource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports